import React, { useEffect, useState } from "react";

function getNextDates() {
const checkDate = new Date();
checkDate.setHours(0, 0, 0, 0);
checkDate.setDate(checkDate.getDate() + 2); // Skip tomorrow

const results = [];
const counts = { 2: 0, 5: 0 };

while (counts[2] < 1 || counts[5] < 1) {
const day = checkDate.getDay();

if ((day === 2 || day === 5) && counts[day] < 1) {
results.push({
value: checkDate.toISOString().split("T")[0],
label: checkDate.toLocaleDateString("en-US", {
weekday: "long",
month: "long",
day: "numeric",
year: "numeric",
}),
});

counts[day]++;
}

checkDate.setDate(checkDate.getDate() + 1);
}

return results;
}

const DateDropdown = ({ onDateChange }) => {
const [dates, setDates] = useState([]);
const [selectedDate, setSelectedDate] = useState("");

useEffect(() => {
// Start searching from the day AFTER tomorrow
const checkDate = new Date();
checkDate.setHours(0, 0, 0, 0);
checkDate.setDate(checkDate.getDate() + 2);

const results = [];
const counts = {
2: 0, // Tuesday
5: 0, // Friday
};

while (counts[2] < 1 || counts[5] < 1) {
const day = checkDate.getDay();

if ((day === 2 || day === 5) && counts[day] < 1) {
results.push(new Date(checkDate));
counts[day]++;
}

checkDate.setDate(checkDate.getDate() + 1);
}

results.sort((a, b) => a - b);
setDates(results);
}, []);

return (
<select
    value={selectedDate}
    onInvalid={(e) => 
        e.target.setCustomValidity("Please select a delivery date from dropdown")
    }
    onInput={(e) => e.target.setCustomValidity("")}
    onChange={(e) => {
        setSelectedDate(e.target.value);
        onDateChange(e.target.value);
    }}
    style={{
        margin: "25px 0 0 0",
        border: "1px solid #d4cece",
        width: "300px",
        padding: "8px"
    }}
    required
>
<option value="">Select Preferred Delivery Date</option>
{dates.map((date) => (
<option
key={date.toISOString()}
value={date.toISOString().split("T")[0]}
>
{date.toLocaleDateString("en-US", {
weekday: "long",
month: "long",
day: "numeric",
year: "numeric",
})}
</option>
))}
</select>
);
};

export default DateDropdown;